import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private apiService: ApiService) { }

  getChatRoom(id) {
    return this.apiService.get('/chat/room/' + id)
      .pipe(map(data => data));
  }

  addContact(userid, appId) {
    return this.apiService.post('/chat/create-contacts', {user_id: userid, app_id: appId})
      .pipe(map(data => data));
  }

  getContacts() {
    return this.apiService.get('/chat/all/messages')
      .pipe(map(data => data));
  }

  sendMessage(msg, rcv) {
    return this.apiService.post('/chat/message', {message: msg, receiver: rcv})
      .pipe(map(data => data));
  }

  markAsRead(rcv) {
    return this.apiService.put('/chat/read-messages', {partner_id : rcv});
  }
}
